export const getAudienceSectionStyle = (_, { palette = {} }) => ({
  sectionContainer: {
    '& label': {
      fontSize: 18,
    },

    '& .audience-dimensions': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '4px',
      margin: '8px 0',

      '& .audience-dimension': {
        alignItems: 'center',
        backgroundColor: palette.neutralLighter,
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'row',
        gap: '6px',
        fontWeight: 600,
        padding: '6px 2px 6px 12px',

        '& button': {
          color: palette.neutralSecondary,
          height: 'auto',

          '& .ms-Icon': {
            fontSize: 12,
          },
        },
      },
    },
  },
});
